export default "__VITE_ASSET__DmbOwYHZ__"